/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { fileModelSchema } from "./fileModelSchema.ts";
import { notificationConditionTypeEnumSchema } from "./notificationConditionTypeEnumSchema.ts";
import { notificationStatusModelSchema } from "./notificationStatusModelSchema.ts";
import { z } from "zod";

export const notificationModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор"),
"name": z.string().describe("Название"),
"description": z.string().describe("Описание"),
"conditionType": z.lazy(() => notificationConditionTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Instant</b>: Моментально всем</li>\n<li><b>2 - AtTime</b>: В указанное время</li>\n</ul>\n"),
"sendOnDate": z.string().datetime({ offset: true }).describe("Дата отправки (для условия отправки - в указанное время)").nullable().nullish(),
"picture": z.lazy(() => fileModelSchema).describe("Обложка").nullable().nullish(),
"deliveryStatus": z.lazy(() => notificationStatusModelSchema).describe("Статус отправки")
    })